import * as actions from '../security-groups.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { SecurityDto } from 'src/app/admin/security-groups/details/models/dto/securityDto';

export interface SecurityState {
    security: SecurityDto;
    loading: LoadingTypes;
}

const initialState: SecurityState = {
    security: null,
    loading: LoadingTypes.INIT
};

export function securityGroupsSecurityReducer(state: SecurityState, action: Action) {
    return createReducer(
        initialState,
        on(actions.loadSecurityGroupsSecurity, (currentState) => ({
            ...currentState,
            loading: LoadingTypes.LOADING
        })),

        on(actions.loadSecurityGroupsSecuritySuccess, (currentState, action) => ({
            ...currentState,
            security: action.security,
            loading: LoadingTypes.LOADED
        })),

        on(actions.loadSecurityGroupsSecurityFail, (currentState) => ({
            ...currentState,
            loading: LoadingTypes.LOADED
        }))
    )(state, action);
}

export function reducer(state: SecurityState | undefined, action: Action) {
    return securityGroupsSecurityReducer(state, action);
}
